import Category from '@common/models/Category';
import Close from '@images/Close.svg';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { CategoryContext } from '../../../../common/context/CategoryContext';
import {
  useCategoryAttributesForm,
  UseCategoryAttributesReturnType,
} from '../../../../common/context/CategoryContext/hooks';
import CategorySidebarItem from './CategorySidebarItem';
// import PriceForm from './PriceFormSlider';
import ProductAttributesForm from './ProductAttributesForm';

interface CategorySidebarProps {
  category: Category;
  categoryAttributesForm?: UseCategoryAttributesReturnType;
  hideCategories?: boolean;
}

const CategorySidebar: React.FC<CategorySidebarProps> = ({ category, categoryAttributesForm, hideCategories }) => {
  const { categoryAttributes, categoryProductsSlice } = useContext(CategoryContext);
  const dispatch = useDispatch();
  const newCategoryAttributeForm =
    categoryAttributesForm ||
    useCategoryAttributesForm({
      categoryProductsSlice,
      categoryAttributes,
      dispatch,
      shouldFetchOnFacetChange: true,
      shouldFetchOnPriceChange: true,
    });
  const {
    computedFormFacetProperties: { FACET_TAGS, onFacetTagClick },
  } = newCategoryAttributeForm;
  return (
    <>
      {FACET_TAGS.length ? (
        <div className="w-full">
          <div className="flex flex-row justify-between mb-22">
            <div className="text-black font-bold leading-19 tracking-16 text-16" font-customisation="section-heading">
              SELECTED
            </div>
            <span
              className="cursor-pointer  text-14 text-gray tracking-14 leading-15 font-bold underline"
              onClick={() => {
                newCategoryAttributeForm.form.setValues({});
              }}
              font-customisation="para-text"
            >
              CLEAR ALL
            </span>
          </div>

          <div className="space-y-22 mb-42">
            {FACET_TAGS.map((facetTag) => (
              <div
                key={facetTag.facetKey}
                className="flex text-black font-medium md:w-full justify-between cursor-pointer text-16 items-center"
                onClick={() => {
                  onFacetTagClick(facetTag);
                }}
              >
                <div className="justify-self-start" font-customisation="para-text">
                  {facetTag.facetValue}
                </div>
                <div className="justify-self-end ">
                  <img src={Close} alt="close" className="w-10 h-10" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}
      {!hideCategories ? (
        <div className="text-theme cursor-pointer mb-82">
          {category.childCategories?.map((childCategory) => (
            <div key={childCategory.id}>
              <CategorySidebarItem category={childCategory} />
              <hr className="border-border border-t-2 my-8" />
            </div>
          ))}
        </div>
      ) : null}
      <ProductAttributesForm categoryAttributesForm={newCategoryAttributeForm} />
    </>
  );
};

export default CategorySidebar;
